import { graphql } from 'react-relay';

const CreateCommentMutation = graphql`
    mutation CreateCommentMutation($input: CommentTypeInput!, $connections: [ID!]!) {
        createComment(input: $input) @prependEdge(connections: $connections) {
            cursor
            node {
                id
                commentable_type
                commentable_id
                text
                commentator {
                    id
                    name
                    first_name
                    last_name
                }
                created_at
                updated_at
            }
        }
    }
`;

export default CreateCommentMutation;
